















































export default {
  name: 'Addition',
  props: {
    name: {
      type: String
    }
  },
  computed: {
    drawer: {
      get(): string {
        return (this as any).$store.state.drawer;
      },
      set(value: boolean) {
        (this as any).$store.dispatch('setDrawer', value);
      }
    }
  },
  methods: {
    openMail() {
      const mail = 'h.s.hyunsik@gmail.com';
      const subject = 'Front End Developer';
      window.open(`mailto:${mail}?subject=${subject}`);
    },
    makeCall() {
      window.parent.location.href = 'tel:+316 26256439';
    },
    addToFavorites() {
      window.alert('Please add this website to your bookmarks with ctrl+d');
      // https://stackoverflow.com/questions/3230499/add-to-favourites-link-for-google-chrome
    },

    // Makes an element be centered vertically on the screen @focus
    // focusScroll(currentTarget, 75, 0, true)
    // @focus($event.currentTarget)
    focusScroll(
      currentTarget: HTMLElement,
      mobileMargin = 150,
      desktopMargin = 750,
      desktopDisabled = false
    ) {
      const tabletBreakpoint = 768;
      const y = currentTarget.getBoundingClientRect().top;
      if (document.documentElement.clientWidth <= tabletBreakpoint) {
        window.scrollBy({
          behavior: 'smooth',
          top: y - mobileMargin
        });
      } else if (
        document.documentElement.clientWidth > tabletBreakpoint &&
        !desktopDisabled
      ) {
        window.scrollBy({
          behavior: 'smooth',
          top: y - desktopMargin
        });
      }
    }
  }
};
